import React from 'react'
import { MerchantContext, SetupMerchant } from './index'
import { MessageStoreContext, SetupMessageStore } from './useMessageStore'

export const GlobalContext = ({ children }: { children?: React.ReactNode }) => {
  return (
    <MerchantContext.Provider value={SetupMerchant()}>
      <MessageStoreContext.Provider value={SetupMessageStore()}>
        {children}
      </MessageStoreContext.Provider>
    </MerchantContext.Provider>
  )
}

export default GlobalContext
